import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEBSSS } from "src/base/context/EBSSSContext/useEBSSS";
import { useDispatch, useSelector } from "react-redux";
import { ReduxDataKey } from "../../base/store/store";
import { cleanErrorsAndMessages, Session, signOut } from "../../base/store/authSlice";
import { Layout } from "src/base/store/layoutSlice";
import { remotePath } from "src/base/settings/Paths";
import CMSLayout from "src/Pages/CMS/CMSLayout";
import { useEBSSSLayout } from "src/base/context/EBSSSLayoutContext/useEBSSSLayout";
import loadjs from "loadjs";
import EBSSSModal from "src/base/atoms/EBSSSModal";
import { CSS } from "src/_utils/styles";
import ProductPage from "../Products/ProductPage";
import { handleFormSubmit } from "./Handlers/handleFormSubmit";
import { handleLinkClick } from "./Handlers/handleLinkClick";
import { renderLoading } from "./Renders/renderLoading";
import EBSSSLoading from "src/base/atoms/EBSSSLoading";
import { joinedLoadingElementClassNames } from "src/base/constants/layout";
import flatpickr from "flatpickr";
import { renderEntity } from "./Renders/renderEntity";
import { renderAvailabilityMessage, renderHourly } from "./Renders/renderRental";
import { renderCalendar } from "./Renders/renderCalendar";
import { renderAgeRange } from "./Renders/renderAgeRange";
import { handleTemplateNormalizer } from "./Handlers/handleTemplateNormalizer";
import { RenderReactChatInstance } from "src/assets/chat/chat";
import EBSSSChatContainer from "src/base/atoms/EBSSSChatContainer";
import { EBSSSChatModule } from "src/assets/chat/core";
import { FORBIDDEN_SCRIPTS } from "src/Constant/scripts";
import EBSSSLoadingCMS from "src/base/atoms/EBSSSLoadingCMS";

const cmsStyleButtons = {
  addCheckout: {
    className: "bg-white btn btn-light border text-dark px-4 border-danger fw-light",
    style: {
      backgroundColor: "#FFF",
      color: "#000",
      borderWidth: 1,
      borderRadius: 30,
      borderColor: "#D41F26",
      padding: 10,
    },
  },
  add: {
    className: "bg-white btn btn-light border text-dark px-4 border-danger fw-light",
    style: {
      backgroundColor: "#FFF",
      color: "#000",
      borderWidth: 1,
      borderRadius: 30,
      borderColor: "#D41F26",
      padding: 10,
    },
  },
};

const mainReplacers = (htmlString) => {
  let startHtmlString = htmlString;

  startHtmlString = startHtmlString.replaceAll(`onchange="window.location.href=value"`, `onchangereplaced="redirector"`);
  startHtmlString = startHtmlString.replaceAll(/(<a[^>]+)href="[^"]*\/auth\/sign-out-cms"([^>]*>)/g, '$1onclickreplaced="logout"$2');
  startHtmlString = startHtmlString.replaceAll(`/crm/cart`, "/checkout");
  startHtmlString = startHtmlString.replaceAll(`/crm/favorites`, "/favorites");
  startHtmlString = startHtmlString.replaceAll(`/cms-form/`, "/form/");
  startHtmlString = startHtmlString.replaceAll(`/cms/sort`, "");
  startHtmlString = startHtmlString.replaceAll(
    `[calendar]`,
    `<div style='display:flex;flex-direction:column;'><div id="calendar" style='display:block; width: 100%; height: 100%;'></div></div>`
  );
  // startHtmlString = startHtmlString.replaceAll(/\/platform-images\/(?!.*icon.*)/g, "/platform-images/v2/");
  startHtmlString = startHtmlString.replaceAll(/\/platform-images\/(?=.*clientlazy=1)(?=.*fill=transparent)/g, "/platform-images/v2/");

  return startHtmlString;
};

const CMSRender = () => {
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);
  const sessionNow: Session = useSelector((state) => state[ReduxDataKey.AUTH]);
  const {
    htmlPage,
    htmlPageSettings,
    product,
    loadedHtml,
    productVariation,
    hasChats,
    chatDataPreview,
    chatDataSetter,
    appSettings,
    fetchProduct,
    setProduct,
    setProductVariation,
    addBookmarks,
    fetchProductVariation,
    setLoadedHtml,
    resetLoginState,
    addItemToCart,
    setAppSettings,
    checkDatesEntity,
    setHasChats,
    setChatDataPreview,
    setChatDataSetter,
  } = useEBSSS();

  const { cmsSnapshot, changeLanguage, trans } = useEBSSSLayout();
  const navigate = useNavigate();
  const [bodyEl, setBodyEl] = useState<{ content: string; scripts: Array<any>; urls: Array<any>; code: Array<any> }>({
    content: "",
    scripts: [],
    urls: [],
    code: [],
  });
  const paramsPage = useParams();
  const [, setSearchParams] = useSearchParams();
  const dispatcher = useDispatch();
  const [modalAddProduct, setModalAddProduct] = useState(false);
  const containerRef = useRef(null);
  const [optionProductSelected, setOptionProductSelected] = useState(null);
  const [variationSelected, setVariationSelected] = useState(null);
  const [variationChain, setVariationChain] = useState([]);
  const [currentlyVariations, setCurrentlyVariations] = useState(null);
  const [currentlyIdVariations, setCurrentlyIdVariations] = useState(null);
  const [tempProductToAddModal, setTempProductToAddModal] = useState(null);
  const [tempAppSettingsToAddModal, setTempAppSettingsToAddModal] = useState(null);
  const [loadElement, setLoadElement] = useState(null);
  const location = useLocation();

  const toggleModalAddProduct = () => {
    setModalAddProduct(!modalAddProduct);
  };

  const logout = () => {
    resetLoginState();
    dispatcher(signOut() as any);
    navigate(process.env.PUBLIC_URL + "?action=logout");
  };

  function handleChange(event, vch, index) {
    const selectedValue = event.target.value;

    if (!selectedValue) {
      return;
    }
    if (vch?.type === "product") {
      setProduct(vch.value.find((vchP) => Number(vchP.id) === Number(selectedValue)));
      return;
    }

    setVariationSelected(selectedValue);

    let getChildLevel = Number(event.target.id.replace("child", ""));

    Array.from(document.querySelector(`#child${getChildLevel}`).parentElement.children).forEach((elSel) => {
      if (Number(elSel.id.replace("child", "")) > getChildLevel) {
        elSel?.remove();
      }
    });

    console.log("to ", getChildLevel);

    if (variationChain.length > index + 1) {
      setVariationChain(variationChain.slice(0, index + 1));
    }
  }

  function renderVariations(vch, startId, index) {
    const container = startId.parentElement;

    const select = document.createElement("select");
    select.className = "select2 form-control mt-1";
    select.name = `child${index + 2}`;
    select.id = `child${index + 2}`;
    select.onchange = (e) => {
      return handleChange(e, vch, index);
    };

    // Create and append the default option
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.textContent = vch.group_name || "Select";
    select.appendChild(defaultOption);

    // Add options from the `vch.value` array
    if (vch.value[0] !== null && vch.value && vch.value.length > 0) {
      vch.value.forEach((optionItem) => {
        const option = document.createElement("option");
        option.value = optionItem?.id;
        option.textContent = optionItem?.name;
        select.appendChild(option);
      });
    } else {
      const option = document.createElement("option");
      option.textContent = trans("website.unavailable");
      option.disabled = true;
      select.appendChild(option);
    }

    container.appendChild(select);
  }

  function getContentBetweenHeaderAndFooter() {
    const parser = new DOMParser();
    const doc = parser.parseFromString(cmsSnapshot, "text/html");

    handleTemplateNormalizer(doc);

    const header = doc.querySelector("header");
    const footer = doc.querySelector("footer");

    if (!header || !footer) {
      console.error("Header or footer not found in the provided HTML.");
      return "";
    }

    let loadContainer = document.createElement("div");

    let loadIndicator = document.createElement("div");
    loadIndicator.style.height = "90vh";
    loadIndicator.classList.add("d-flex");
    loadIndicator.classList.add("m-auto");
    loadIndicator.classList.add("align-items-center");
    loadIndicator.classList.add("justify-content-center");
    // loadIndicator.appendChild(renderLoading(ebsssLayout, true));
    loadIndicator.appendChild(renderLoading(ebsssLayout, false, trans("common.loading")));

    loadContainer.appendChild(header);
    loadContainer.appendChild(loadIndicator);
    loadContainer.appendChild(footer);

    doc.body.innerHTML = loadContainer.innerHTML;

    return doc.body.innerHTML;
  }

  function getOutermostParent(element, formRef) {
    let outermostParent = element;

    while (outermostParent.parentElement && outermostParent.parentElement !== formRef) {
      outermostParent = outermostParent.parentElement;
    }
    return outermostParent;
  }

  useEffect(() => {
    if (optionProductSelected) {
      let { price, photo, title } =
        product?.options
          ?.map((po) => po?.values)
          ?.flat()
          ?.find((op) => op?.token === optionProductSelected?.value) ?? {};

      setProduct({
        ...product,
        price,
        photo,
        title: product?.title + " " + title,
      });
      document.querySelector(".class_variation_product_price").textContent = ebsssLayout.commonAppSettings?.currency_symbol + " " + price;
    }
  }, [optionProductSelected]);

  useEffect(() => {
    if (variationChain[variationChain.length - 1]?.type === "product" && htmlPageSettings?.type === "crm_product") {
      document.querySelector(".iclient-cart")?.classList?.remove("d-none");
    }
  }, [variationChain, variationSelected]);

  useEffect(() => {
    if (variationChain.length > 0 && htmlPageSettings?.type === "crm_product") {
      renderVariations(variationChain[variationChain.length - 1], document.querySelector(".level1"), variationChain.length + 1);
    }
  }, [variationChain]);

  useEffect(() => {
    if (product?.settings?.productsChild && product?.settings?.productsChild?.length > 0 && !currentlyVariations && !currentlyIdVariations) {
      setCurrentlyVariations(product?.settings?.productsChild);
      setCurrentlyIdVariations(product?.id);
    }
  }, [product?.id]);

  useEffect(() => {
    if (product && variationSelected && currentlyVariations && currentlyVariations?.length > 0 && htmlPageSettings?.type === "crm_product") {
      fetchProductVariation(currentlyIdVariations, variationSelected, null);
    }
  }, [variationSelected]);

  useEffect(() => {
    if (productVariation && htmlPageSettings?.type === "crm_product") {
      setVariationChain((s) => [...s, productVariation]);
    }
  }, [productVariation]);

  useEffect(() => {
    if (product?.product_payment_types && Array.isArray(product?.product_payment_types)) {
      window["PRODUCT_PAYMENT_TYPE"] = product?.product_payment_types[0]?.payment_type?.token;
    }
  }, [product?.product_payment_types]);

  useEffect(() => {
    if (htmlPage) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlPage, "text/html");

      let bodyTag = doc.body;

      let bodyContent = bodyTag.outerHTML;
      let bodyElData: { content: string; scripts: Array<any>; urls: Array<any>; code: Array<any> } = {
        content: bodyContent,
        scripts: [],
        urls: [],
        code: [],
      };

      //Body
      if (window["BUILD_MODE"] === "DEV" || localStorage.getItem(window.location.host?.toUpperCase() + "_REACT_SCRIPT_INJECTION") === "true") {
        const bodyScripts = Array.from(bodyTag.querySelectorAll("script"));
        if (bodyScripts.length > 0) {
          bodyScripts.forEach((link) => {
            // let scriptName = link?.getAttribute("src")?.split("?")?.shift()?.split("/")?.pop();
            // console.log("script name: ", scriptName);
            // if (alreadyLoadedScripts.includes(scriptName)) {
            //   let fullUrlLinkHref = `${process.env.PUBLIC_URL}/scripts/${scriptName}`;
            //   link.setAttribute("src", `${fullUrlLinkHref + (fullUrlLinkHref.includes("?") ? fullUrlLinkHref + "&" : "?") + "cms=true"}`);
            //   return;
            // }
            if (link.getAttribute("src") && link.getAttribute("src").startsWith("/")) {
              let fullUrlLinkHref = `${remotePath.clientInstanceUrl()}${link.getAttribute("src")}`;
              link.setAttribute("src", `${fullUrlLinkHref + (fullUrlLinkHref.includes("?") ? fullUrlLinkHref + "&" : "?") + "cms=true"}`);
            }
          });

          bodyTag.querySelectorAll("script").forEach((e) => e?.remove());
          if (bodyTag.querySelector(".cart-wrap")) {
            let oldCartItem = bodyTag.querySelector(".cart-wrap");
            oldCartItem.innerHTML = "";
            oldCartItem.classList.add("me-5");
          }
          if (bodyTag.querySelector(".header-cart")) {
            let oldCartItem = bodyTag.querySelector(".header-cart");
            oldCartItem.innerHTML = "";
          }
          if (bodyTag.querySelector(".template-product-extras-container")) {
            let extrasContainer = bodyTag.querySelector(".template-product-extras-container");
            extrasContainer.classList.add("d-flex", "flex-wrap");
          }
          if (bodyTag.querySelector("header")) {
            let headerMenu = bodyTag.querySelector("header");
            if (headerMenu.querySelectorAll("li")?.length > 0) {
              headerMenu.querySelectorAll("li")?.forEach((li) => {
                if (li?.className?.includes("menu-item-has-children") && li?.querySelector("ul") && li?.querySelector("ul").children.length === 0) {
                  li.className = "";
                  li.querySelector("ul").remove();
                }
              });
            }
          }
          bodyTag.querySelector(joinedLoadingElementClassNames)?.remove();
          bodyContent = bodyTag.outerHTML;
          bodyElData = {
            ...bodyElData,
            content: bodyContent,
          };
        }

        bodyElData = {
          ...bodyElData,
          scripts: bodyScripts,
          urls: bodyScripts.map((elsc) => elsc.src).filter((elsc) => elsc.trim()),
          code: bodyScripts.filter((elsc) => elsc.textContent && elsc.getAttribute("element-template")).map((elsc) => elsc.textContent),
        };
      }

      setBodyEl({
        ...bodyElData,
      });

      let intervalCheckContentSet = setInterval(() => {
        console.log("Checking root-inner to add static listeners (redir, logout, add product...)");
        if (document && document.querySelector("#root-inner") && document.querySelector("#root-inner")?.children?.length > 0) {
          const elementsWithOnChange = Array.from(document.querySelectorAll("[onchangereplaced]"));
          const elementsWithOnClick = Array.from(document.querySelectorAll("[onclickreplaced]"));

          console.log(elementsWithOnChange, elementsWithOnClick);

          if (elementsWithOnChange.length > 0) {
            elementsWithOnChange?.forEach((e) => {
              if (e.getAttribute("onchangereplaced") === "redirector") {
                e.addEventListener("change", (event) => {
                  const value = event.target["value"];
                  if (value) {
                    setSearchParams(`${value}`);
                  }
                });
              }
            });
          }

          if (elementsWithOnClick.length > 0) {
            elementsWithOnClick?.forEach((e) => {
              if (e.getAttribute("onclickreplaced") === "logout") {
                e.addEventListener("click", logout);
              }
            });
          }

          if (htmlPageSettings) {
            if (htmlPageSettings?.type === "crm_product") {
              if (product?.options?.length > 0) {
                product.options.forEach((opt) => {
                  if (opt.values && opt?.values?.length > 0) {
                    opt.values.forEach((opv, i) => {
                      if (i === 0) {
                        console.log(opv.product_option_id);
                        setOptionProductSelected({
                          option: opt.token,
                          value: opv.token,
                          product_option_id: opv.product_option_id,
                          price: product?.options?.find((optFind) => optFind.token === opt.token)?.values?.find((valFind) => valFind.token === opv.token)
                            ?.price,
                        });
                      }
                    });
                  }
                });
              }
              if (document.querySelector(".iclient-cart")) {
                document.querySelectorAll(".iclient-cart").forEach((el) => {
                  if (el.getAttribute("href") === "Não") {
                    el?.remove();
                  }
                });

                if (
                  product?.settings?.shiftTimes &&
                  Object.values(product?.settings?.shiftTimes) &&
                  Object.values(product?.settings?.shiftTimes)?.length === 1
                ) {
                  window["PRODUCT_SLOT"] = Object.values(product?.settings?.shiftTimes)[0];
                }

                if (product?.product_entities && product?.product_entities?.length === 1) {
                  window["PRODUCT_ENTITY"] = product?.product_entities[0]?.id;
                }

                if (product?.product_extras && Array.isArray(product?.product_extras)) {
                  document.querySelectorAll('[name="extra[]"').forEach((el) => {
                    el.addEventListener("click", () => {
                      if (!window["PRODUCT_EXTRAS"]) {
                        window["PRODUCT_EXTRAS"] = [];
                      }
                      let val = product?.product_extras?.find((ext) => ext.token === el.getAttribute("value"));

                      if (val) {
                        let selectedExtrasBefore = [...window["PRODUCT_EXTRAS"]];
                        if (selectedExtrasBefore.includes(val.id)) {
                          window["PRODUCT_EXTRAS"] = selectedExtrasBefore.filter((x) => x !== val.id);
                          return;
                        }
                        let marked = document.createElement("div");
                        let markedText = document.createElement("span");
                        markedText.textContent = "✓";
                        markedText.style.margin = "auto";
                        markedText.style.maxHeight = "75%";
                        markedText.style.justifyContent = "center";
                        markedText.style.display = "flex";
                        markedText.style.alignItems = "center";
                        markedText.style.fontSize = "x-small";

                        marked.style.width = "13.5px";
                        marked.style.height = "13.5px";
                        marked.style.position = "absolute";
                        marked.style.backgroundColor = "#AFF435";
                        marked.style.color = "#FFFFFF";
                        marked.style.textAlign = "center";
                        marked.style.justifyContent = "center";
                        marked.style.display = "flex";
                        marked.style.borderRadius = "3px";
                        marked.style.border = "1.5px solid #228b22";
                        marked.appendChild(markedText);
                        marked.onclick = () => {
                          if (!window["PRODUCT_EXTRAS"]) {
                            window["PRODUCT_EXTRAS"] = [];
                          }
                          window["PRODUCT_EXTRAS"] = selectedExtrasBefore.filter((x) => x !== val.id);
                          marked?.remove();
                        };
                        el.after(marked);
                        window["PRODUCT_EXTRAS"] = [...selectedExtrasBefore, val.id];
                      }
                    });
                  });
                }

                if (product?.product_payment_types && Array.isArray(product?.product_payment_types) && product?.product_payment_types?.length > 1) {
                  let checkIfHasPaymenyTypeTag = document.querySelector(".iclient-payment-types");
                  let getButtonsContainerUntilFormContainer, getContainer;

                  if (!checkIfHasPaymenyTypeTag) {
                    getContainer = document.querySelector(".iclient-cart").closest("form");
                    getButtonsContainerUntilFormContainer = getOutermostParent(document.querySelector(".iclient-cart"), getContainer);
                  } else {
                    getContainer = document.querySelector(".iclient-payment-types").closest("form");
                    checkIfHasPaymenyTypeTag = checkIfHasPaymenyTypeTag.parentElement;
                  }

                  if (getContainer) {
                    let paymentMethodLabel = document.createElement("p");
                    paymentMethodLabel.textContent = trans("billing.payment_type");

                    let paymentMethodContainer = document.createElement("div");
                    paymentMethodContainer.style.display = "flex";
                    paymentMethodContainer.style.flexDirection = "row";
                    paymentMethodContainer.style.rowGap = "20px";
                    paymentMethodContainer.style.columnGap = "10px";
                    paymentMethodContainer.style.marginBottom = "10px";
                    paymentMethodContainer.style.flexWrap = "wrap";

                    let removeOtherBorderColors = () => {
                      paymentMethodContainer.querySelectorAll("span").forEach((div) => {
                        div["style"].backgroundColor = "#f9f9f9";
                        div["style"].color = "#000";
                      });
                    };

                    console.log(product?.product_payment_types);

                    product?.product_payment_types?.forEach((paymentType, idxPt) => {
                      let paymentMethod = document.createElement("div");
                      paymentMethod.style.display = "inline-block";

                      let paymentName = document.createElement("span");
                      paymentName.id = paymentType?.payment_type?.token;
                      paymentName.style.backgroundColor = idxPt === 0 ? "#AFF435" : "#f9f9f9";
                      paymentName.style.color = idxPt === 0 ? "#FFF" : "#000";
                      paymentName.style.borderRadius = "25px";
                      paymentName.style.padding = "10px";
                      paymentName.style.borderColor = "#f9f9f9";
                      paymentName.style.borderWidth = "1px";
                      paymentName.style.cursor = "pointer";
                      paymentName.textContent = paymentType?.payment_type?.name;

                      paymentMethod.addEventListener("click", (e) => {
                        console.log("From listener: ", paymentType?.payment_type?.token);
                        window["PRODUCT_PAYMENT_TYPE"] = paymentType?.payment_type?.token;
                        removeOtherBorderColors();
                        paymentName["style"].backgroundColor = "#AFF435";
                        paymentName["style"].color = "#fff";
                      });
                      paymentMethod.appendChild(paymentName);
                      paymentMethodContainer.appendChild(paymentMethod);
                    });
                    if (getButtonsContainerUntilFormContainer) {
                      getContainer.insertBefore(paymentMethodContainer, getButtonsContainerUntilFormContainer);
                      getContainer.insertBefore(paymentMethodLabel, paymentMethodContainer);
                    } else {
                      checkIfHasPaymenyTypeTag.appendChild(paymentMethodContainer);
                    }
                  }
                }
              }
              if (product?.settings?.customFields) {
                // handleProductCustomField(product, setUserCustomFields);
              }
              if (document?.querySelector(".iclient-cart-option_price")) {
                document?.querySelector(".iclient-cart-option_price")?.addEventListener("change", (e) => {
                  let childrenOption = e.target["value"];
                  let optionsToFind = product?.options?.map((po) => po.values)?.flat();
                  let copyOptionsToFind = product?.options;
                  let opt = optionsToFind.find((o) => o.token === childrenOption);

                  setOptionProductSelected({
                    value: childrenOption,
                    price: opt?.price,
                    product_option_id: opt?.product_option_id,
                    option: copyOptionsToFind.find((o) => o.values.find((ov) => ov.token === childrenOption))?.token,
                  });
                });
              }
              if (document?.querySelector(".iclient-cart-variations")) {
                document?.querySelector(".level1")?.addEventListener("change", (e) => {
                  let variationValue = e.target["value"];
                  document.querySelectorAll('[id^="child"]').forEach((el) => el?.remove());
                  setVariationSelected(variationValue);
                  setVariationChain([]);
                });
              }
              if (document.querySelectorAll('input[type="radio"]:not([value])')) {
                document.querySelectorAll('input[type="radio"]:not([value])').forEach((el) => el?.remove());
              }
              if (product?.entities && product?.entities.length > 0 && document.querySelector("#calendar")) {
                //@ts-ignore
                document.querySelector("#calendar")["style"].display = "flex";
                document.querySelector("#calendar")["style"].width = "100%";
                document.querySelector("#calendar")["style"].height = "auto";
                let getContainerCalendar = document.querySelector("#calendar").parentElement;

                getContainerCalendar.style.marginBottom = "20px";

                function listenToWindowProp(propName, callback) {
                  let currentValue = window[propName];

                  Object.defineProperty(window, propName, {
                    get() {
                      return currentValue;
                    },
                    set(newValue) {
                      const oldValue = currentValue;
                      currentValue = newValue;
                      if (callback && typeof callback === "function") {
                        callback(newValue, oldValue);
                      }
                    },
                    configurable: true,
                  });
                }

                // Example usage
                listenToWindowProp("PRODUCT_ENTITY", (newValue, oldValue) => {
                  if (window["PRODUCT_ENTITY"] && window["PRODUCT_RENTAL_DATE"]) {
                    console.log(`PRODUCT_ENTITY changed from ${oldValue} to ${newValue}`);
                    let elLoading = renderAvailabilityMessage(trans);
                    document.querySelector("#renderHourly")?.after(elLoading);
                    document.querySelector("#renderHourly")?.remove();
                    refreshEntityAvailability((res) => {
                      elLoading.remove();
                      getContainerCalendar.appendChild(
                        renderHourly(trans, product, window["PRODUCT_RENTAL_DATE"], (v) => (window["PRODUCT_SLOT"] = v), window["PRODUCT_SLOT"], res)
                      );
                    });
                  }
                });

                listenToWindowProp("PRODUCT_RENTAL_DATE", (newValue, oldValue) => {
                  if (window["PRODUCT_ENTITY"] && window["PRODUCT_RENTAL_DATE"]) {
                    console.log(`PRODUCT_RENTAL_DATE changed from ${oldValue} to ${newValue}`);
                    let elLoading = renderAvailabilityMessage(trans);
                    document.querySelector("#renderHourly")?.after(elLoading);
                    document.querySelector("#renderHourly")?.remove();
                    refreshEntityAvailability((res) => {
                      elLoading.remove();
                      getContainerCalendar.appendChild(
                        renderHourly(trans, product, window["PRODUCT_RENTAL_DATE"], (v) => (window["PRODUCT_SLOT"] = v), window["PRODUCT_SLOT"], res)
                      );
                    });
                  }
                });

                listenToWindowProp("PRODUCT_RENTAL_START_END_DATE", (newValue, oldValue) => {
                  console.log(`PRODUCT_RENTAL_START_END_DATE changed from ${oldValue} to ${newValue}`);
                  if (newValue?.rental_start_at !== oldValue?.rental_start_at) {
                    if (window["PRODUCT_RENTAL_START_END_DATE"]["rental_end_at"]) {
                      window["PRODUCT_RENTAL_START_END_DATE"]["rental_end_at"] = null;
                    }
                    if (window["PRODUCT_RENTAL_START_END_DATE"]["rental_end_at_time"]) {
                      window["PRODUCT_RENTAL_START_END_DATE"]["rental_end_at_time"] = null;
                    }
                    document.querySelector("#calendar_2")?.previousElementSibling?.remove();
                    document.querySelector("#calendar_2")?.nextElementSibling?.remove();
                    document.querySelector("#calendar_2")?.remove();

                    let createOtherCalendar = document.createElement("div");
                    createOtherCalendar.id = "calendar_2";
                    getContainerCalendar.appendChild(createOtherCalendar);
                    renderCalendar(
                      trans,
                      {
                        enableTime: true,
                        inline: false,
                        disable: [
                          function (date) {
                            if (date.getTime() < new Date(window["PRODUCT_RENTAL_START_END_DATE"]?.rental_start_at).getTime()) return true;
                            return false;
                          },
                        ],
                      },
                      (v) => {
                        console.log("Changed calendar: ", v);
                        window["PRODUCT_RENTAL_START_END_DATE"] = {
                          ...window["PRODUCT_RENTAL_START_END_DATE"],
                          rental_end_at: v[0]?.toISOString()?.split("T")[0],
                          rental_end_at_time: v[0]?.toISOString()?.split("T")[1]?.replace(".000Z", ""),
                        };
                      },
                      "#calendar_2",
                      "common.to"
                    );
                  }
                });

                let refreshEntityAvailability = async (cb) => {
                  if (product?.settings?.slots && window["PRODUCT_ENTITY"]) {
                    let getEntityId = product?.settings?.entitiesAvailable?.find((ett) => ett.token === window["PRODUCT_ENTITY"]);
                    if (getEntityId) {
                      console.log("Entity getted: ", getEntityId);
                      window["PRODUCT_SLOT"] = {};
                      console.log("getEntityId: ", getEntityId);
                      if (!window["PRODUCT_RENTAL_DATE"] && !Array.isArray(window["PRODUCT_RENTAL_DATE"])) {
                        checkDatesEntity(
                          product?.slug,
                          getEntityId?.id,
                          new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate()
                        ).then((r) => {
                          window["PRODUCT_ENTITY_DATE_AVAILABILITY"] = r;
                          cb(r);
                        });
                      } else {
                        checkDatesEntity(product?.slug, getEntityId?.id, window["PRODUCT_RENTAL_DATE"]).then((r) => {
                          window["PRODUCT_ENTITY_DATE_AVAILABILITY"] = r;
                          cb(r);
                        });
                      }
                    }
                  }
                };

                if (product?.settings?.productAgeRanges) {
                  getContainerCalendar.appendChild(
                    renderAgeRange(
                      product,
                      appSettings,
                      window["PRODUCT_AGE_RANGES"],
                      function (v) {
                        console.log(v);
                        if (!window["PRODUCT_AGE_RANGES"]) {
                          window["PRODUCT_AGE_RANGES"] = {};
                        }
                        window["PRODUCT_AGE_RANGES"] = { ...window["PRODUCT_AGE_RANGES"], ...{ [`quantity_${v.group}`]: v.value } };
                        console.log("Actual group range: ", window["PRODUCT_AGE_RANGES"]);
                      },
                      trans
                    )
                  );
                }

                if (product?.rental_type === "shift_time") {
                  function handleChangeShiftTime(e, t = null) {
                    console.log(
                      "Shift token: ",
                      Object.values(product?.settings?.shiftTimes)?.find((sft) => sft["token"] === (t ? t : e?.target?.value))
                    );
                    window["PRODUCT_SHIFT"] = Object.values(product?.settings?.shiftTimes)?.find((sft) => sft["token"] === (t ? t : e?.target?.value));
                  }

                  renderCalendar(trans, {
                    onChange: (v) => {
                      let dayUpdate = v[0];

                      if (product?.settings?.shiftTimes) {
                        const checkShiftTiming = Object.values(product?.settings?.shiftTimes).map((sts: Record<any, any>) => {
                          return { ...sts, week_day: sts["week_day"]?.split(",") };
                        });

                        const fromWeek = String(dayUpdate.getDay());

                        console.log("fromWeek: ", fromWeek);

                        let foundShiftTime = checkShiftTiming.filter((st) => st.week_day.length !== 7)?.find((st) => st?.week_day?.includes(fromWeek));

                        console.log("foundShiftTime: ", foundShiftTime);

                        if (checkShiftTiming?.length === 1 || !foundShiftTime) {
                          checkShiftTiming.find((st) => st?.week_day?.includes(fromWeek));
                        }

                        if (foundShiftTime) {
                          handleChangeShiftTime(null, foundShiftTime["token"]);
                        }
                      }
                      window["PRODUCT_RENTAL_DATE"] = dayUpdate;
                    },
                  });
                }
                if (product?.rental_type === "hourly" && product?.entity_rent_minutes_fraction) {
                  let minMaxDates = {};

                  if (product?.entity_reservation_start_at) {
                    minMaxDates["minDate"] =
                      new Date(product?.entity_reservation_start_at).getTime() <= new Date().getTime()
                        ? new Date()
                        : new Date(product?.entity_reservation_start_at);
                  }

                  if (product?.entity_reservation_end_at) {
                    minMaxDates["maxDate"] = new Date(product?.entity_reservation_end_at);
                  }

                  console.log("minMaxDates: ", minMaxDates);

                  getContainerCalendar.prepend(
                    renderEntity(product, trans, (e) => {
                      console.log("Changed entity: ", e.target.value);
                      window["PRODUCT_ENTITY"] = e.target.value;
                    })
                  );

                  renderCalendar(
                    trans,
                    {
                      ...minMaxDates,
                    },
                    (v) => {
                      console.log("Changed calendar: ", v);
                      window["PRODUCT_RENTAL_DATE"] = v[0];
                    }
                  );

                  getContainerCalendar.appendChild(
                    renderHourly(
                      trans,
                      product,
                      window["PRODUCT_RENTAL_DATE"],
                      (v) => (window["PRODUCT_SLOT"] = v),
                      window["PRODUCT_SLOT"],
                      window["PRODUCT_ENTITY_DATE_AVAILABILITY"] ?? []
                    )
                  );
                }
                if (product?.rental_type === "hourly" && !product?.entity_rent_minutes_fraction) {
                  renderCalendar(
                    trans,
                    {
                      enableTime: true,
                      inline: false,
                    },
                    (v) => {
                      console.log("Changed calendar: ", v);
                      window["PRODUCT_RENTAL_START_END_DATE"] = {
                        ...window["PRODUCT_RENTAL_START_END_DATE"],
                        rental_start_at: v[0]?.toISOString()?.split("T")[0],
                        rental_start_at_time: v[0]?.toISOString()?.split("T")[1].replace(".000Z", ""),
                      };
                    }
                  );
                  let createOtherCalendar = document.createElement("div");
                  createOtherCalendar.id = "calendar_2";
                  getContainerCalendar.appendChild(createOtherCalendar);
                  renderCalendar(
                    trans,
                    {
                      enableTime: true,
                      inline: false,
                      disable: [
                        function (date) {
                          if (date.getTime() < new Date(window["PRODUCT_RENTAL_START_END_DATE"]?.rental_start_at).getTime()) return true;
                          return false;
                        },
                      ],
                    },
                    (v) => {
                      console.log("Changed calendar: ", v);
                      window["PRODUCT_RENTAL_START_END_DATE"] = {
                        ...window["PRODUCT_RENTAL_START_END_DATE"],
                        rental_end_at: v[0]?.toISOString()?.split("T")[0],
                        rental_end_at_time: v[0]?.toISOString()?.split("T")[1]?.replace(".000Z", ""),
                      };
                    },
                    "#calendar_2",
                    "common.to"
                  );
                }
                if (product?.rental_type === "daily") {
                  renderCalendar(trans, { mode: "range" }, (v) => {
                    console.log(v);
                    if (v.length !== 2) return;
                    let start = v[0]?.toISOString()?.split("T")[0];
                    let end = v[1]?.toISOString()?.split("T")[0];
                    window["PRODUCT_RENTAL_DATE"] = start + " - " + end;
                  });
                }
              }
            }
          }

          clearInterval(intervalCheckContentSet);
        }
      }, 1000);
    }
  }, [htmlPage, htmlPageSettings]);

  useEffect(() => {
    if (product?.settings?.productAgeRanges) {
      product?.settings?.productAgeRanges?.forEach((ageRange) => {
        if (!window["PRODUCT_AGE_RANGES"]) {
          window["PRODUCT_AGE_RANGES"] = {};
        }
        window["PRODUCT_AGE_RANGES"] = {
          ...window["PRODUCT_AGE_RANGES"],
          ...{ [`quantity_${ageRange?.age_range?.uuid}`]: String(ageRange.participants_min ?? 0) },
        };
      });
    }
  }, [product?.settings?.productAgeRanges]);

  useEffect(() => {
    if (product?.settings?.shiftTimes && Object.values(product?.settings?.shiftTimes) && Object.values(product?.settings?.shiftTimes).length === 1) {
      window["PRODUCT_SHIFT"] = Object.values(product?.settings?.shiftTimes)[0];
    }
  }, [product?.settings?.shiftTimes]);

  useEffect(() => {
    if (!modalAddProduct && htmlPageSettings?.type === "crm_product") {
      setProduct(null);
      setAppSettings(null);
    }
  }, [modalAddProduct, setAppSettings, setProduct]);

  useEffect(() => {
    setModalAddProduct(false);
  }, [sessionNow?.session?.cart?.length]);

  useEffect(() => {
    let submitHandler = (event) => handleFormSubmit(event, null, null, ebsssLayout, navigate, sessionNow?.token ?? "");
    let clickHandler = (event) =>
      handleLinkClick(
        event,
        ebsssLayout,
        sessionNow,
        product,
        window["PRODUCT_PAYMENT_TYPE"],
        window["PRODUCT_EXTRAS"],
        window["PRODUCT_RENTAL_DATE"],
        window["PRODUCT_SLOT"],
        window["PRODUCT_SHIFT"],
        window["PRODUCT_ENTITY"],
        window["PRODUCT_AGE_RANGES"],
        window["PRODUCT_RENTAL_START_END_DATE"],
        optionProductSelected,
        paramsPage,
        appSettings,
        tempProductToAddModal,
        tempAppSettingsToAddModal,
        htmlPageSettings,
        handleFormSubmit,
        navigate,
        trans,
        addItemToCart,
        changeLanguage,
        dispatcher,
        addBookmarks,
        setModalAddProduct,
        fetchProduct,
        setTempProductToAddModal,
        setTempAppSettingsToAddModal
      );
    document?.addEventListener("submit", submitHandler);
    document?.addEventListener("click", clickHandler);

    return () => {
      document.removeEventListener("submit", submitHandler);
      document.removeEventListener("click", clickHandler);
    };
  }, [document, product]);

  const filterLibs = (libLink) => {
    return libLink.filter((lib) => FORBIDDEN_SCRIPTS?.find((fl) => !lib.includes(fl)));
  };

  useEffect(() => {
    let guaranteeRenderingTimer = setTimeout(() => {
      requestAnimationFrame(() => {
        let toAddSc = [];
        if (
          (window["BUILD_MODE"] === "DEV" && bodyEl.urls?.length > 0) ||
          localStorage.getItem(window.location.host?.toUpperCase() + "_REACT_SCRIPT_INJECTION") === "true"
        ) {
          console.log("Checking if has scripts to add...");
          filterLibs(bodyEl.urls)?.forEach((sc) => {
            console.log("+ scripts being checked if it was added before...");
            if (!document.querySelector(`script[src="${sc}"]`)) {
              console.log("+ Script wasnt added before: ", sc);
              toAddSc.push(sc);
            }
          });

          if (toAddSc.length > 0) {
            let startTime = new Date().getTime();
            console.log("+ Scripts wasnt added before");
            loadjs(toAddSc, "all-scripts", {
              async: false,
              numRetries: 3,
              before: function (path, scriptEl) {
                scriptEl["defer"] = true; // Ensures script execution order
              },
            });
            loadjs.ready("all-scripts", () => {
              console.log(">>> Scripts loaded");
              bodyEl.code.forEach((st) => {
                console.log(">>> Adding script: ", st);
                let createElScript = document.createElement("script");
                createElScript.async = true;
                createElScript.textContent = st;
                document.body.appendChild(createElScript);
              });
              let delayToScriptsActivation = setTimeout(() => {
                console.log(">>> Showing content after scripts loaded");
                setLoadedHtml(true);
                handleTemplateNormalizer();
                clearTimeout(delayToScriptsActivation);
              }, 500);
            });
            let endTime = new Date().getTime();
            console.log("Diff Time: ", endTime - startTime);
          } else {
            setLoadedHtml(true);
          }
        }
        clearTimeout(guaranteeRenderingTimer);
      });
    }, 0);

    return () => {
      if (window["BUILD_MODE"] === "DEV" || localStorage.getItem(window.location.host?.toUpperCase() + "_REACT_SCRIPT_INJECTION") === "true") {
        console.log("- Unmounting scripts...");
        loadjs.reset();
        bodyEl.urls?.forEach((sc) => {
          if (document.querySelector(`script[src="${sc}"]`)) {
            document.querySelector(`script[src="${sc}"]`)?.remove();
          }
        });
      }
    };
  }, [bodyEl.urls]);

  useEffect(() => {
    if (!loadedHtml && cmsSnapshot) {
      handleTemplateNormalizer();
      let feedbackLoading = getContentBetweenHeaderAndFooter();
      setLoadElement(feedbackLoading);
    }
  }, [loadedHtml]);

  useEffect(() => {
    return () => {
      setCurrentlyIdVariations(null);
      setCurrentlyVariations(null);
      setProductVariation(null);
      dispatcher(cleanErrorsAndMessages());
      document.querySelectorAll("script").forEach((el) => el.remove());
    };
  }, []);

  useEffect(() => {
    if (loadedHtml && document.querySelector("#root-inner") && location.state?.anchoring) {
      let elToGo = document.querySelector(`#${location.state?.anchoring.replace("/#", "").replace("#", "")}`);
      if (elToGo) {
        console.log("Found anchor");
        elToGo.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [document, loadedHtml]);

  return (
    <CMSLayout>
      {/* {loadedHtml ? <></> : <EBSSSLoading />} */}
      {!loadElement && !loadedHtml ? <EBSSSLoadingCMS /> : <></>}
      {loadedHtml ? <></> : <div dangerouslySetInnerHTML={{ __html: loadElement }} />}
      <div ref={containerRef} className={loadedHtml ? "" : "d-none"} id="root-inner" dangerouslySetInnerHTML={{ __html: mainReplacers(bodyEl.content) }} />
      <div style={CSS({ display: !loadElement && !loadedHtml ? "none" : "block" })}>
        {hasChats?.length > 0 ? (
          hasChats?.map((ch) => {
            console.log("Guid config: ", ch);
            if (ch.type !== "pop") return <></>;
            if (localStorage.getItem("NOT_FOUND_CHAT_" + ch.guid) === "true") return <></>;
            //@ts-ignore
            new EBSSSChatModule(ch).init();
            return (
              <EBSSSChatContainer chatDataSetter={chatDataSetter} guidData={ch} chatDataPreview={chatDataPreview}>
                <RenderReactChatInstance
                  {...(ch as any)}
                  sufixGUID={ch.guid}
                  chatDataSetter={chatDataSetter}
                  setChatDataSetter={setChatDataSetter}
                  setChatDataPreview={setChatDataPreview}
                />
              </EBSSSChatContainer>
            );
          })
        ) : (
          <></>
        )}
      </div>
      <EBSSSModal
        hideFooter
        hideSubmitButton
        style={CSS({ borderRadius: 15 })}
        modalTitle="Adicionar ao Carrinho"
        modal={modalAddProduct}
        toggle={toggleModalAddProduct}
        triggerEl={<></>}
      >
        <div style={CSS({ marginLeft: "3rem", marginRight: "3rem", marginTop: "3rem" })}>
          <ProductPage
            isCMS={true}
            cmsStyleButtons={true ? {} : cmsStyleButtons}
            cmsOption={optionProductSelected}
            cmsVariation={variationSelected}
            cmsExtra={window["PRODUCT_EXTRAS"]}
            cmsPaymentType={window["PRODUCT_PAYMENT_TYPE"]}
            cmsDate={window["PRODUCT_RENTAL_DATE"]}
            cmsShift={window["PRODUCT_SHIFT"]}
            cmsSlot={window["PRODUCT_SLOT"]}
            cmsEntity={window["PRODUCT_ENTITY"]}
            cmsAgeRange={window["PRODUCT_AGE_RANGES"]}
            cmsDateStartEnd={window["PRODUCT_RENTAL_START_END_DATE"]}
            openModal={modalAddProduct}
            callbackCloseModal={toggleModalAddProduct}
          />
        </div>
      </EBSSSModal>
    </CMSLayout>
  );
};

export default CMSRender;
